var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.697 6.303c.343.343.343.9 0 1.243l-6.151 6.15a.879.879 0 0 1-1.243-1.242l6.151-6.15a.88.88 0 0 1 1.243 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.03 8.757c.343.344.343.9 0 1.243l-1.243 1.243a3.515 3.515 0 0 0 4.97 4.97L10 14.971a.879.879 0 1 1 1.243 1.242L10 17.456A5.272 5.272 0 1 1 2.544 10l1.243-1.243a.88.88 0 0 1 1.242 0M10 2.544A5.272 5.272 0 1 1 17.456 10l-1.243 1.243A.879.879 0 1 1 14.971 10l1.242-1.243a3.515 3.515 0 1 0-4.97-4.97L10 5.029a.879.879 0 0 1-1.243-1.242z",
    clipRule: "evenodd"
  })));
};
export default SvgLink;